import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { fetchAdminKpis } from "../api/reports";
import "./admin-dashboard.css";

export const AdminDashboard = (): JSX.Element | null => {
    const { data, error, isLoading } = useQuery({
        queryKey: ["admin", "kpis"],
        queryFn: fetchAdminKpis,
        staleTime: 60 * 1000
    });

    if (error && (error as any)?.response?.status === 403) {
        // Not an admin: hide dashboard
        return null;
    }

    if (isLoading) {
        return <div className="admin-dashboard__loading">Loading KPIs...</div>;
    }

    if (!data) {
        return null;
    }

    return (
        <section className="admin-dashboard" aria-label="Admin dashboard">
            <h2>Admin Dashboard</h2>
            <div className="admin-dashboard__kpis">
                <div className="kpi-card">
                    <p className="kpi-card__label">Active assignments</p>
                    <p className="kpi-card__value">{data.activeAssignmentsCount}</p>
                </div>
                <div className="kpi-card">
                    <p className="kpi-card__label">Completed last 7 days</p>
                    <p className="kpi-card__value">{data.completedAssignmentsLast7Days}</p>
                </div>
                <div className="kpi-card">
                    <p className="kpi-card__label">Deliveries last 7 days</p>
                    <p className="kpi-card__value">{data.deliveriesLast7Days}</p>
                </div>
                <div className="kpi-card">
                    <p className="kpi-card__label">Pending registrations</p>
                    <p className="kpi-card__value">{data.pendingRegistrations}</p>
                </div>
                <div className="kpi-card">
                    <p className="kpi-card__label">Last import at</p>
                    <p className="kpi-card__value">{data.lastImportAt ? new Date(data.lastImportAt).toLocaleString() : "N/A"}</p>
                </div>
                <div className={`kpi-card ${data.unreportedRoGroupsCount > 0 ? "kpi-card--warning" : ""}`}>
                    <p className="kpi-card__label">Orapporterade RO-grupper</p>
                    <p className="kpi-card__value">{data.unreportedRoGroupsCount}</p>
                    {data.unreportedRoGroupsCount > 0 && (
                        <Link to="/admin/ro-reporting" className="kpi-card__link">
                            Hantera →
                        </Link>
                    )}
                </div>
            </div>
            <div className="admin-dashboard__actions">
                <a className="export-button" href="/api/reports/deliveries/export" target="_self" rel="noopener">
                    Download deliveries CSV
                </a>
            </div>
        </section>
    );
};